import { Box, Button, Grow, IconButton, Paper, Stack, Tooltip, Typography } from '@mui/material'
import { useEffect, useState } from 'react'
import ToastMsg from '../../../../Components/ToastMsg/ToastMsg'
import { Colors } from '../../../../Styles/Colors'
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';
import { useHistory } from 'react-router-dom/cjs/react-router-dom';
import { newAmountCard } from '../../../../Components/CommonCards/CommonCards';
import { DataGrid } from '@mui/x-data-grid';
import { ImagePaths } from '../../../../Utility/ImagePaths';
import { DateTime } from 'luxon';
import { AmountFormat, formatDate } from '../../../../Components/CommonFunctions/CommonFunctions';
import { CommonGridToolBarWithFilterText, CommonPatientDetails } from '../../../../Components/Common Components/CommonComponents';
import RestAPIService from '../../../../Utility/Services/RestAPIService';
import { Serviceurls } from '../../../../Utility/API/Serviceurls';

const STYLES = {
    FONT_SIZE_LOW_2: "0.9rem",
    FONT_SIZE_LOW_3: "0.8rem",
    FONT_WEIGHT: "bold"
};

const DetailSerConsolidate = () => {
    const [states, setStates] = useState({
        ServiceConsolidateData: [],
        page: 0,
        pageSize: 10,
        isLoader: false,
        doctorName: '',
        serviceHeadName: '',
        total_service_count: 0,
        total_amount: 0,
        doctor_share: 0,
        selectedDoc: null,
        module_type: '',
        serviceType: '',
        patientType: '',
        fromDate: DateTime.fromJSDate(new Date()).toFormat('yyyy-MM-dd'),
        toDate: DateTime.fromJSDate(new Date()).toFormat('yyyy-MM-dd'),
    })
    const [message, setMessage] = useState({
        isErrorMsgText: '',
        successMsgText: '',
        isErrorMsg: false,
        successMsg: false,
    })
    const history = useHistory()

    const errorMessage = (message) => {
        setMessage({
            ...message,
            isErrorMsg: true,
            isErrorMsgText: message,
            transmit: false,
            saveLoad: false
        })
    }

    const msgClose = () => {
        setMessage({
            ...message,
            isErrorMsg: false,
            isErrorMsgText: '',
            successMsg: false,
            successMsgText: ''
        })
    }

    // API STARTS

    useEffect(() => {
        if (Object.keys(history?.location?.state?.serviceData)?.length > 0 || Object.keys(history?.location?.state?.filterData)?.length > 0) {
            let serviceData = history?.location?.state?.serviceData
            let filterData = history?.location?.state?.filterData
            setStates((prev) => ({
                ...prev,
                doctorName: serviceData?.bill_doctor,
                serviceHeadName: serviceData?.service_head,
                fromDate: filterData?.fromDate,
                toDate: filterData?.toDate,
                total_service_count: serviceData?.count,
                total_amount: serviceData?.total_amount,
                doctor_share: serviceData?.doctor_share,
                selectedDoc: serviceData?.doctor_id,
                module_type: serviceData?.module_type,
                serviceType: serviceData?.service_head,
                patientType: filterData?.patientType,
            }))
            getServiceConsolidateReport(serviceData, filterData)
        }
    }, [history?.location?.state?.serviceData, history?.location?.state?.filterData])

    const getServiceConsolidateReport = (serviceData, filterData) => {
        try {
            setStates((prev) => ({
                ...prev,
                isLoader: true
            }))
            let Type = !filterData?.patientType || filterData?.patientType.length === 0 ? ['Outpatient', 'Inpatient', 'Individual'].join(',') : filterData.patientType.map((type) => type.value).join(',');
            let params = `?from_date=${filterData?.fromDate}&to_date=${filterData?.toDate}&view_type=detailed&target_doctor=${serviceData?.doctor_id}&target_module=${serviceData?.module_type}&target_service=${serviceData?.service_head}&patient_type=${Type}&is_sharable=${filterData?.isSharable || false}`
            RestAPIService.getAll(Serviceurls.DOCTOR_SERVICE_CONSOLIDATE + params)
                .then((response) => {
                    if (response?.data?.status === 'success') {
                        setStates((prev) => ({
                            ...prev,
                            ServiceConsolidateData: response?.data?.data?.data ?? [],
                            isLoader: false
                        }))
                    }
                }).catch(error => {
                    setStates((prev) => ({ ...prev, isLoader: false }))
                    if (error?.response?.data?.message) {
                        errorMessage(error?.response?.data?.message)
                    } else {
                        errorMessage(error.message)
                    }
                })
        } catch (error) {
            setStates((prev) => ({ ...prev, isLoader: false }))
            errorMessage(error.message)
        }
    }

    const gridToolBar = () => {
        let TextArray = [
            { label: "From Date", value: formatDate(states.fromDate) },
            { label: "To Date", value: formatDate(states.toDate) },
        ]
        return (
            <Box><CommonGridToolBarWithFilterText FilterTextArray={TextArray} /></Box>

        )
    }

    const renderTable = () => {
        states?.ServiceConsolidateData?.forEach((element, index) => element.sno = index + 1)
        const columns = [
            {
                field: "patient_name", headerName: "Patient Details", flex: 0.22,
                renderCell: ({ row }) => (<Box component={'div'}><CommonPatientDetails data={row} /></Box>), valueGetter: (params) => {
                    const Name = params.row?.patient_name || '';
                    const Mobile = params.row?.patients_mobile_number || '';
                    const UHID = params.row?.patient_account_number || '';
                    return `${Name} ${Mobile} ${UHID}`;
                }
            },
            {
                field: "invoice_number", headerName: "Invoice Number", flex: 0.12, headerAlign: "center", align: "center",
                renderCell: (params) => (<Box component={'div'}>{params?.row?.invoice_number ? <Tooltip placement='top' title={params?.row?.invoice_number} arrow>
                    <Box>{params?.row?.invoice_number ?
                        "..." + params?.row?.invoice_number.slice(9) : params?.row?.invoice_number}</Box>
                </Tooltip> : "-"}</Box>)
            },
            {
                field: 'invoice_date', headerName: 'Invoice date', flex: 0.15, headerAlign: 'center', align: "center", type: 'string',
                valueGetter: (params) => params.row?.invoice_date,
                renderCell: (params) => {
                    let Date = params?.row?.invoice_date
                    return (
                        <Box component={'div'}>
                            <Typography>{Date || '-'}</Typography>
                        </Box>
                    )
                }
            },
            {
                field: 'service_name', headerName: 'Service Name', flex: 0.27,
                renderCell: (params) => {
                    let service = params?.row?.service_name
                    return (
                        <Box component={'div'}>
                            {service ? service?.length > 35 ?
                                <Tooltip placement='top' title={service}><Typography>{service?.slice(0, 35) + '...'}</Typography></Tooltip> :
                                <Typography>{service}</Typography> : '-'}
                        </Box>
                    )
                }
            },
            {
                field: 'count', headerName: 'Unit', flex: 0.05, headerAlign: 'center', align: "center",
                renderCell: (params) => {
                    let count = params?.row?.count
                    return (
                        <Box component={'div'}>
                            {count ? count?.length > 5 ?
                                <Tooltip placement='top' title={count}><Typography>{count?.slice(0, 5) + '...'}</Typography></Tooltip> :
                                <Typography>{count}</Typography> : '-'}
                        </Box>
                    )
                }
            },
            {
                field: 'total_amount',
                headerName: 'Total Amount',
                flex: 0.145,
                headerAlign: 'right',
                align: 'right',
                type: 'number',
                valueGetter: (params) => Number(params.row?.total_amount || 0),
                renderCell: (params) => {
                    const amount = params.row?.total_amount
                    return (
                        <Box>
                            {amount ? <Typography>{amount}</Typography> : '-'}
                        </Box>
                    )
                }
            },
            {
                field: 'doctor_share',
                headerName: 'Doctor Share',
                flex: 0.145,
                headerAlign: 'right',
                align: 'right',
                type: 'number',
                valueGetter: (params) => Number(params.row?.doctor_share || 0),
                renderCell: (params) => {
                    const share = params.row?.doctor_share
                    return (
                        <Box>
                            {share ? <Typography>{share}</Typography> : '-'}
                        </Box>
                    )
                }
            }
        ]
        return (
            <Box component={'div'} className='eMed_rts_table'>
                <DataGrid
                    rows={states.ServiceConsolidateData}
                    columns={columns}
                    getRowId={(row) => row['sno']}
                    page={states.page}
                    pageSize={states.pageSize}
                    localeText={{
                        toolbarColumns: "",
                        toolbarDensity: "",
                        toolbarExport: "",
                        toolbarFilters: "",
                        toolbarExportPrint: ""
                    }}
                    components={{
                        Toolbar: gridToolBar,
                        NoRowsOverlay: () => (
                            <Box className='eMed_conf_nodata'>
                                {'No Records To Be Shown'}
                            </Box>
                        )
                    }}
                    onPageChange={(newPage) => { setStates((prev) => ({ ...prev, page: newPage })) }}
                    onPageSizeChange={(newPageSize) => setStates((prev) => ({ ...prev, pageSize: newPageSize }))}
                    rowsPerPageOptions={[10, 20, 30]}
                    pagination
                    headerHeight={40}
                    disableSelectionOnClick
                    loading={states.isLoader}
                />
            </Box>
        )
    }

    return (
        <Box component={'div'} sx={{ height: '85dvh', backgroundColor: Colors.Background }}>
            <Box component={'div'}>
                <Box component={'div'} mb={'0.5rem'} paddingX={'0.75vw'}>
                    <Box component={'div'} height={'5dvh'} borderBottom={'2px solid lightgray'} display={'flex'} alignItems={'center'}>
                        <IconButton
                            onClick={() => {
                                history?.push({
                                    pathname: '/FOReports/PatientReport/ServiceConsolidateReport',
                                    state: {
                                        fromDate: states.fromDate,
                                        toDate: states.toDate,
                                        dateIndex: history?.location?.state?.filterData?.dateIndex,
                                        doctorName: history?.location?.state?.filterData?.doctorName,
                                        serviceType: history?.location?.state?.filterData?.serviceType,
                                        ModuleType: history?.location?.state?.filterData?.ModuleType,
                                        patientType: history?.location?.state?.filterData?.patientType,
                                        isSharable: history?.location?.state?.filterData?.isSharable,
                                        fromDetailed: true
                                    }
                                })
                                setStates((prev) => ({ ...prev, serviceHeadId: null }))
                            }}
                        ><KeyboardBackspaceIcon color='primary' /></IconButton>
                        <Typography fontSize={'1rem'} fontWeight={600}>{'Back To Overview'}</Typography>
                    </Box>
                    <Box>
                        <Paper className="eMed_PharmaVendor_paper" sx={{ height: '5vw' }} elevation={2}>
                            <Stack direction="row" sx={{ padding: "1vw" }} spacing={18}>
                                <Stack spacing={1}>
                                    <Typography>{"Doctor Name"}</Typography>
                                    <Tooltip title={(states?.doctorName || '-')} placement="top" arrow>
                                        {
                                            states?.doctorName && states?.doctorName?.length > 25 ?
                                                <Typography style={{ fontSize: "1rem", fontWeight: "bold" }}>{(states?.doctorName).slice(0, 25) + "..."}</Typography>
                                                :
                                                <Typography style={{ fontSize: "1rem", fontWeight: "bold" }} noWrap>{states?.doctorName || '-'}</Typography>
                                        }
                                    </Tooltip>
                                </Stack>
                                <Stack spacing={1}>
                                    <Typography>{"Service Head"}</Typography>
                                    <Tooltip title={(states?.serviceHeadName || '-')} placement="top" arrow>
                                        {
                                            states?.serviceHeadName && states?.serviceHeadName?.length > 25 ?
                                                <Typography style={{ fontSize: "1rem", fontWeight: "bold" }}>{(states?.serviceHeadName).slice(0, 25) + "..."}</Typography>
                                                :
                                                <Typography style={{ fontSize: "1rem", fontWeight: "bold" }} noWrap>{states?.serviceHeadName || '-'}</Typography>
                                        }
                                    </Tooltip>
                                </Stack>
                                <Stack spacing={1}>
                                    <Typography>{"Total Service Count"}</Typography>
                                    <Typography style={{ fontSize: "1rem", fontWeight: "bold" }}>{states?.total_service_count || 0}</Typography>
                                </Stack>
                                <Stack spacing={1}>
                                    <Typography>{"Total Amount"}</Typography>
                                    <Typography style={{ fontSize: "1rem", fontWeight: "bold" }}>{AmountFormat(states?.total_amount || 0)}</Typography>
                                </Stack>
                                <Stack spacing={1}>
                                    <Typography>{"Doctor Share"}</Typography>
                                    <Typography style={{ fontSize: "1rem", fontWeight: "bold" }}>{AmountFormat(states?.doctor_share || 0)}</Typography>
                                </Stack>
                            </Stack>
                        </Paper>
                    </Box>
                </Box>
                <Box component={'div'}>
                    {renderTable()}
                </Box>
            </Box>
            {message.isErrorMsg ?
                <ToastMsg
                    severity={'error'}
                    msg={message.isErrorMsgText}
                    msgPop={msgClose}
                />
                : null}
            {message.successMsg ?
                <ToastMsg
                    severity={'success'}
                    msg={message.successMsgText}
                    msgPop={msgClose}
                />
                : null}
        </Box>
    )
}

export default DetailSerConsolidate
